// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { SectionContainer, SectionTitle } from "@conklin/App/Widgets/DesignSystem/DesignSystem.helpers";
import { longText } from "@conklin/App/Widgets/DesignSystem/DummyData/DummyData";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import Button from "@insite/mobius/Button";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC, useContext } from "react";
import { css } from "styled-components";

interface ToastTabStyles {
    titleGridItem?: GridItemProps;
    gridItem?: GridItemProps;
    toastWrapper?: InjectableCss;
}

const toastTabStyles: ToastTabStyles = {
    titleGridItem: {
        width: 12,
    },
    gridItem: {
        width: 12,
        css: css`
            flex-wrap: wrap;
            padding-bottom: 40px;
        `,
    },
    toastWrapper: {
        css: css`
            display: flex;
            justify-content: space-between;
            width: 100%;
            margin-top: 20px;
            flex-wrap: wrap;
        `,
    },
};

const styles = toastTabStyles;
const ToastTab: FC = props => {
    const toasterContext = useContext(ToasterContext);

    return (
        <SectionContainer>
            <GridItem {...styles.titleGridItem}>
                <SectionTitle>{translate("Toast")}</SectionTitle>
            </GridItem>
            <GridItem {...styles.gridItem}>
                <StyledWrapper {...styles.toastWrapper}>
                    <Button
                        color="success"
                        onClick={() =>
                            toasterContext.addToast({
                                title: "Toast - Success",
                                body: "Success",
                                messageType: "success",
                            })
                        }
                        aria-label="Success Message Toast"
                    >
                        Success
                    </Button>

                    <Button
                        color="danger"
                        onClick={() =>
                            toasterContext.addToast({ title: "Toast - Danger", body: "Danger", messageType: "danger" })
                        }
                        aria-label="Danger Message Toast"
                    >
                        Danger
                    </Button>
                    <Button
                        color="info"
                        onClick={() =>
                            toasterContext.addToast({ title: "Toast - Info", body: "Info", messageType: "info" })
                        }
                        aria-label="Info Message Toast"
                    >
                        Info
                    </Button>
                    <Button
                        color="warning"
                        onClick={() =>
                            toasterContext.addToast({
                                title: "Toast - Warning",
                                body: "Warning",
                                messageType: "warning",
                            })
                        }
                        aria-label="Warning Message Toast"
                    >
                        Warning
                    </Button>
                    <Button
                        onClick={() =>
                            toasterContext.addToast({
                                title: "Toast - title",
                                body: "message",
                                messageType: "success",
                            })
                        }
                        aria-label="Short Message Toast"
                    >
                        Short Message - Toast
                    </Button>
                    <Button
                        variant="secondary"
                        onClick={() =>
                            toasterContext.addToast({
                                title: "Toast - title",
                                body: longText,
                                messageType: "success",
                            })
                        }
                        aria-label="Long Message Toast"
                    >
                        Long Message - Toast
                    </Button>
                </StyledWrapper>
            </GridItem>
        </SectionContainer>
    );
};

export default ToastTab;
